/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Select_Preset_TextInputs */

const en_preset_manager_select_preset_text = /** @type {(inputs: Preset_Manager_Select_Preset_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a preset to view details`)
};

const fr_preset_manager_select_preset_text = /** @type {(inputs: Preset_Manager_Select_Preset_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez un preset pour voir les details`)
};

const de_preset_manager_select_preset_text = /** @type {(inputs: Preset_Manager_Select_Preset_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Voreinstellung aus, um Details anzuzeigen.`)
};

const it_preset_manager_select_preset_text = /** @type {(inputs: Preset_Manager_Select_Preset_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un preset per visualizzare i dettagli`)
};

const ru_preset_manager_select_preset_text = /** @type {(inputs: Preset_Manager_Select_Preset_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите предустановку, чтобы просмотреть подробности.`)
};

const es_preset_manager_select_preset_text = /** @type {(inputs: Preset_Manager_Select_Preset_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un ajuste preestablecido para ver los detalles`)
};

const zh_cn2_preset_manager_select_preset_text = /** @type {(inputs: Preset_Manager_Select_Preset_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择预设以查看详情`)
};

const ja_preset_manager_select_preset_text = /** @type {(inputs: Preset_Manager_Select_Preset_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`詳細を表示するにはプリセットを選択してください`)
};

const hi_preset_manager_select_preset_text = /** @type {(inputs: Preset_Manager_Select_Preset_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विवरण देखने के लिए एक प्रीसेट चुनें`)
};

const pt_pt2_preset_manager_select_preset_text = /** @type {(inputs: Preset_Manager_Select_Preset_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione uma predefinição para ver os detalhes.`)
};

/**
* | output |
* | --- |
* | "Select a preset to view details" |
*
* @param {Preset_Manager_Select_Preset_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_select_preset_text = /** @type {((inputs?: Preset_Manager_Select_Preset_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Select_Preset_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_select_preset_text(inputs)
	if (locale === "de") return de_preset_manager_select_preset_text(inputs)
	if (locale === "it") return it_preset_manager_select_preset_text(inputs)
	if (locale === "ru") return ru_preset_manager_select_preset_text(inputs)
	if (locale === "es") return es_preset_manager_select_preset_text(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_select_preset_text(inputs)
	if (locale === "ja") return ja_preset_manager_select_preset_text(inputs)
	if (locale === "hi") return hi_preset_manager_select_preset_text(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_select_preset_text(inputs)
	return en_preset_manager_select_preset_text(inputs)
});